import fetch from "cross-fetch";
import {API_ROOT} from "../../config";
import {
  CREATE_BUSINESS,
  CREATE_BUSINESS_FAILED,
  RECEIVE_BUSINESS,
  REQUEST_BUSINESS,
  REQUEST_BUSINESS_FAILED
} from "state/actionTypes";
import {
  fetchBusinessById as networkFetchBusinessById,
} from 'services';

function createBusiness(businessInfo) {
  return {
    type: CREATE_BUSINESS,
    businessInfo,
  }
}

function createBusinessFailed(businessInfo) {
  return {
    type: CREATE_BUSINESS_FAILED,
    businessInfo,
  }
}

function requestBusinessBySlug(slug) {
  return {
    type: REQUEST_BUSINESS,
    slug: slug,
  }
}

function requestBusinessById(id) {
  return {
    type: REQUEST_BUSINESS,
    id: id,
  }
}

export function receiveBusiness(business) {
  return {
    type: RECEIVE_BUSINESS,
    item: business
  }
}

export function requestBusinessFailed() {
  return {
    type: REQUEST_BUSINESS_FAILED,
  }
}

export function fetchBusinessBySlug(slug) {
  return dispatch => {
    dispatch(requestBusinessBySlug(slug));
    return fetch(API_ROOT + '/businesses/?slug=' + slug)
      .then(response => response.json())
      .then(businesses => {
        if (businesses.length > 0) {
          return dispatch(receiveBusiness(businesses[0]));
        }
        return dispatch(requestBusinessFailed());
      });
  }
}

export function fetchBusinessById(id) {
  return dispatch => {
    dispatch(requestBusinessById(id));
    return networkFetchBusinessById(id).then(business => dispatch(receiveBusiness(business)));
  }
}

export function fetchBusinessBySlugIfNeeded(slug) {
  return (dispatch, getState) => {
    const state = getState();
    if (!state.business || !state.business.item) {
      return dispatch(fetchBusinessBySlug(slug));
    }
  }
}

export function fetchBusiness() {
  return (dispatch, getState) => {
    const state = getState();
    if (state.auth.token) {
      dispatch(() => ({type: REQUEST_BUSINESS}));
      return fetch(API_ROOT + '/businesses/', {
        headers: {
          'Authorization': 'Token ' + state.auth.token
        }
      }).then(response => response.json(), error => console.error(error)).then(json => {
        // We return only the first business since we don't have multiple businesses per user by design yet.
        dispatch(receiveBusiness(json[0]));
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/state/actions/business.js